export const GTM_EVENT_CATEGORY = 'onboarding';
